const threeDModelRequests = {
  createThreedeeModelRequest: (data) => ({
    url: `api/measurement/prepareModel`,
    method: 'post',
    data,
  }),
}

export default threeDModelRequests
